import React from "react";

/**
 * Inline SVG rather than an icon font: the panel renders on public meeting pages that do not all
 * load Font Awesome, and a missing glyph font degrades to an empty box with no way to tell.
 * Every icon here is decorative -- the adjacent text carries the meaning.
 */
const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
  focusable: false
};

export const GlobeIcon = (): React.JSX.Element => (
  <svg {...base} strokeWidth={1.7}>
    <circle cx="12" cy="12" r="9.2" />
    <path d="M2.8 12h18.4M12 2.8c2.6 2.4 4 5.7 4 9.2s-1.4 6.8-4 9.2c-2.6-2.4-4-5.7-4-9.2s1.4-6.8 4-9.2z" />
  </svg>
);

export const TranscriptIcon = (): React.JSX.Element => (
  <svg {...base} strokeWidth={1.8}>
    <rect x="2.5" y="5" width="19" height="14" rx="2.5" />
    <path d="M7 11h3M14 11h3M7 14.5h6" />
  </svg>
);

export const HeadphonesIcon = (): React.JSX.Element => (
  <svg {...base} strokeWidth={1.8}>
    <path d="M4 14v-2a8 8 0 0 1 16 0v2" />
    <rect x="2.5" y="13.5" width="4" height="7" rx="1.6" />
    <rect x="17.5" y="13.5" width="4" height="7" rx="1.6" />
  </svg>
);

export const PhoneIcon = (): React.JSX.Element => (
  <svg {...base} strokeWidth={1.9}>
    <path d="M5 4h3l1.6 4-2 1.2a12 12 0 0 0 5.2 5.2l1.2-2 4 1.6v3a2 2 0 0 1-2.2 2A16 16 0 0 1 3 6.2 2 2 0 0 1 5 4z" />
  </svg>
);

export const ArrowRightIcon = (): React.JSX.Element => (
  <svg {...base} strokeWidth={2.2}>
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

export const ChevronIcon = (): React.JSX.Element => (
  <svg {...base} className="la-chev" strokeWidth={2}>
    <path d="M6 9l6 6 6-6" />
  </svg>
);
